import templateUrl from "emun.salesrep/top-selling-product-rep-order-count.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import basicController from "servicestack/basic.controller.properties";

class TopSellingProductRepOrderCountController {
  constructor($window, $rootScope, createAutoQuery) {
    let $ctrl = this;
    basicController($ctrl);
    $ctrl.orderByField = "label";
    $ctrl.reverseSort = false;
    $ctrl.mode = "list";
    $ctrl.total = 0;
    $ctrl.repGroupFilter = "";
    $ctrl.label = $ctrl.title || "Top Selling Products";
  }
  $onInit() {
    let $ctrl = this;
    var context = $ctrl.context || "rep";

    var filter = "SalesRepID";
    if (context === "manager") {
      filter = "Manager";
    }
    if (context === "category") {
      filter = "CategoryId";
    }
    if ($ctrl.context === "executive") {
      filter = "";
    }
    var orderBy = "CompanyRanking";

    var salesQueryUrl = "QueryTopSellingProductsByRepByOrderCount.json?";
    if ($ctrl.repGroup) {
      if ($ctrl.repGroup !== "ALL") {
        salesQueryUrl = salesQueryUrl + "&RepGroupName=" + $ctrl.repGroup;
      }
    }
    if (context === "rep") {
      salesQueryUrl =
        salesQueryUrl +
        "GroupBy=ProductID,Description,TerritoryRanking,CompanyRanking";
      salesQueryUrl = salesQueryUrl + "&SalesRepID=" + $ctrl.rep.id;
      orderBy = "CompanyRanking";
      filter = "";
    }
    if (context === "manager") {
      salesQueryUrl =
        salesQueryUrl +
        "GroupBy=ProductID,Description,ManagerRanking,CompanyRanking";
      salesQueryUrl = salesQueryUrl + "&Manager=" + $ctrl.rep.id;
      orderBy = "CompanyRanking";
      filter = "";
    }

    $ctrl.query = new AutoQuery({
      url: salesQueryUrl,
      orderBy: orderBy,
      autoLoad: true,
      pageSize: 50,
      append: false,
      disableSettingStorage: true,
      scrollTop: false,
    });
  }

  downloadData() {
    let $ctrl = this;
    var url = $ctrl.$appConfig.resolveServiceUrl(
      $ctrl.query.url.replace(".json", ".csv")
    );
    return (location.href = url);
  }
}

let TopSellingProductRepOrderCount = {
  bindings: {
    rep: "<",
    repGroup: "@",
    context: "@",
    title: "@",
    insideSales: "@",
    writingRepId: "@",
    salesRepId: "@",
  },
  controller: TopSellingProductRepOrderCountController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default TopSellingProductRepOrderCount;
